<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <div class="topLeft">
        <!-- <h3>推广链接报表<span class="time" v-if="updateTime">数据更新时间：{{timestampToDateTotal(updateTime)}}</span></h3> -->
        <h3>推广链接报表<span class="time">续报人数、续报率、续报金额的数据更新时间为T+1，其余数据均延迟10分钟更新</span></h3>
        <div class="refresh">按照推广链接维度汇总的完整数据链路，按体验课订单支付时间周期来统计</div>
      </div>
      <div class="topRight">
        <el-select v-model="listQuery.dimension" class="selectWidth" @change="toggleSearch">
          <el-option
            v-for="item in allTime"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
        <el-date-picker
          v-model="createTime"
          value-format="timestamp"
          type="daterange"
          :picker-options="pickerOptions"
          :clearable="false"
          @blur="enableChoose"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          style="width:235px"
          @change="changeDate"
          ></el-date-picker>
        <div>按体验课订单支付时间统计</div>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="课程科目" label-width="80px">
          <SubjectCascader :onChange="subjectCascaderChange"/>
        </el-form-item>
        <el-form-item label="推广课程">
          <el-select
            value-key="id"
            v-model="listQuery.course_id"
            multiple
            filterable
            clearable
            placeholder="请选择推广课程"
          >
            <el-option label="全部推广课程" value='all' />
            <el-option
              v-for="item in courseList"
              :key="item.id"
              :label="item.agentCourse.name"
              :value="item.agentCourse.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广渠道">
          <el-select
            value-key="id"
            v-model="listQuery.promotion_channel_id"
            multiple
            filterable
            clearable
            placeholder="请选择推广渠道"
            @change="handleChannel"
          >
            <el-option label="全部推广渠道" value='all' />
            <el-option
              v-for="item in channelList"
              :key="item.id"
              :label="item.name"
              :value="item.promotionChannelCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广位">
          <el-select
            value-key="id"
            v-model="listQuery.promotion_position_id"
            multiple
            filterable
            clearable
            placeholder="请选择推广位"
          >
            <el-option label="全部推广位" value='all' />
            <el-option
              v-for="item in promotionList"
              :key="item.id"
              :label="item.name"
              :value="item.promotionPositionCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="支付金额">
          <el-input v-model="listQuery.pay_amount" type="number" placeholder="输入支付金额" class="orderStyle" />
        </el-form-item>
        <el-form-item label="学习进度">
          <el-select v-model="listQuery.study_step" filterable placeholder="请选择学习进度">
            <el-option :key="0" label="全部" value='all' />
            <el-option :key="1" label="首课已开课" value="首课已开课" />
            <el-option :key="2" label="首课未开课" value="首课未开课" />
            <el-option :key="3" label="续报已截止" value="续报已截止" />
            <el-option :key="4" label="续报未截止" value="续报未截止" />
          </el-select>
        </el-form-item>
        <el-form-item label="开课日期" label-width="80px">
          <el-date-picker
          v-model="listQuery.class_open_time"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="学期">
          <el-select
            v-model="listQuery.term_id"
            value-key="id"
            multiple
            filterable
            clearable
            placeholder="请选择学期"
          >
            <el-option label="全部" value='all' />
            <el-option
              v-for="item in termList"
              :key="item.id"
              :label="`${item.id}·${item.name}(${item.description})`"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="归属人">
          <el-select
            value-key="id"
            v-model="listQuery.member_id"
            multiple
            filterable
            clearable
            placeholder="请选择归属人"
          >
            <el-option label="全部归属人" value='all' />
            <el-option
              v-for="item in teamList"
              :key="item.id"
              :label="item.name"
              :value="item.agentCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推广链接ID">
          <el-input
            v-model="listQuery.promotion_link_id"
            placeholder="多个ID用逗号分隔"
            class="orderStyle"
          />
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
      </el-form>
      <funcBlock tit="详细数据" :showBorder=false>
        <div slot="blockCon">
          <i slot="blockTit" class="blockTit">
            <!-- 下载组件 -->
            <DownExcel
              :listQuery="listQuery"
              :createTime="createTime"
              :total="total"
              pageType="timeChannel"
            />
          </i>
          <!-- // 动态生成表格 -->
          <el-table
            v-loading="listLoading"
            :data="dataList"
            border
            fit
            highlight-current-row
            style="width: 100%, margin-top:100px"
            :header-cell-style="tableHeader"
            :row-class-name="tableColumn"
            @sort-change="changeTableSort"
            :default-sort = "{prop: 'dimension', order: 'descending'}"
          >
            <el-table-column v-if="listQuery.dimension !== 'sum'" label="日期" prop="dimension" align="center" min-width="180" fixed sortable='custom'>
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">
                  {{ `总计 ${total ? numberFormat(total) : total } 条记录` }}
                </span>
                <span v-else>{{ row.dimension ? row.dimension : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="推广链接ID" align="center" min-width="160" fixed>
              <template slot-scope="{row}">
                 <span v-if="listQuery.dimension === 'sum' && row.data_cnt" class="special-weight">
                  {{ `总计 ${total ? numberFormat(total) : total } 条记录` }}
                </span>
                <span v-else-if="row.data_cnt" class="special-weight">
                  {{ listQuery.stat_dimension === 'total' && row.data_cnt ? `总计 ${total ? numberFormat(total) : total } 条记录` : '--' }}
                </span>
                <span v-else>{{ row.promotion_link_id}}</span>
              </template>
            </el-table-column>
            <el-table-column label="推广渠道名称" align="center" width="180">
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">--</span>
                <span v-else-if="row.promotion_channel_name && row.promotion_channel_name.length <= 10">
                  {{ row.promotion_channel_name || '--' }}
                </span>
                <el-tooltip v-else class="item" effect="dark" :content="row.promotion_channel_name" placement="top">
                  <span class="icon-question">
                    {{ row.promotion_channel_name && row.promotion_channel_name.length > 10
                      ? `${row.promotion_channel_name.slice(0, 10)}...` : row.promotion_channel_name || '--'
                    }}
                </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="推广位名称" align="center" width="180">
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">--</span>
                <span v-else-if="row.promotion_position_name && row.promotion_position_name.length <= 10">
                  {{ row.promotion_position_name || '--' }}
                </span>
                <el-tooltip v-else class="item" effect="dark" :content="row.promotion_position_name" placement="top">
                  <span class="icon-question">
                    {{ row.promotion_position_name && row.promotion_position_name.length > 10
                      ? `${row.promotion_position_name.slice(0, 10)}...` : row.promotion_position_name || '--'
                    }}
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="归属人" align="center" min-width="120">
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">--</span>
                <span v-else>{{ row.promotion_user_name && Number(row.promotion_user_name) !== 0 ? row.promotion_user_name : '无归属人' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="体验课支付人数" prop="sum_l1_num" align="center" min-width="150" sortable='custom'>
              <template slot="header">
                <el-tooltip class="item" effect="dark" content="仅包含已支付人数，剔除已退费人数" placement="top">
                  <span class="icon-question">体验课支付人数</span>
                </el-tooltip>
              </template>
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">
                  {{ row.sum_l1_num ? numberFormat(row.sum_l1_num) : '--' }}
                </span>
                <span v-else>{{ row.sum_l1_num ? numberFormat(row.sum_l1_num) : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-for="column in tableColumns"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              :show-overflow-tooltip="true"
              align="center"
              min-width="170"
              sortable='custom'
            >
              <template slot="header"
                v-if="column.label && (column.label.includes('率')
                  || column.label === '全部课完课人数'
                  || column.label === '续报人数'
                  || column.label === '续报金额'
                  || column.label === '续报截止占比'
                  || column.label === '重购人数'
                  || column.label === '重购续报数'
                  || column.label === '重购续报率'
                )"
              >
                <el-tooltip class="item" effect="dark" :content="handlePrompt(column.label)" placement="top">
                  <span class="icon-question">{{ column.label }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">
                  {{ row[column.prop] && row[column.prop] !== '-' ?
                    numberFormatNew(row[column.prop], column.label)
                    : column.label.includes('数') ? 0 : column.label.includes('金额') ? '0.00'
                    : column.label.includes('率') ? '0.00%' : '--'
                  }}
                </span>
                <span v-else>
                  {{ row[column.prop] ? numberFormatNew(row[column.prop], column.label)
                    : column.label.includes('数') ? 0 : column.label.includes('金额') ? '0.00'
                    : column.label.includes('率') ? '0.00%' : '--'
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="推广课程ID" align="center" width="120">
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">--</span>
                <span v-else>{{ row.course_id || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="推广课程名称" align="center" min-width="180">
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">--</span>
                <span v-else-if="row.course_name && row.course_name.length <= 10">
                  {{ row.course_name || '--' }}
                </span>
                <el-tooltip v-else class="item" effect="dark" :content="row.course_name" placement="top">
                  <span class="icon-question">
                    {{ row.course_name && row.course_name.length > 10
                      ? `${row.course_name.slice(0, 10)}...` : row.course_name || '--'
                    }}
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="推广渠道ID" align="center" width="120">
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">--</span>
                <span v-else>{{ row.promotion_channel_id || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="推广位ID" align="center" width="120">
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">--</span>
                <span v-else>{{ row.promotion_position_id || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="归属人ID" align="center" width="120">
              <template slot-scope="{row}">
                <span v-if="row.data_cnt" class="special-weight">--</span>
                <span v-else>{{ row.member_id || '--' }}</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total>=1"
            :total="total"
            :page.sync="listQuery.index"
            :limit.sync="listQuery.pageSize"
            @pagination="getList"
          />
        </div>
      </funcBlock>
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from 'js-cookie';
import Pagination from "@/components/Pagination/index";
import DownExcel from "@/components/DownExcel/index";
import SubjectCascader from "@/components/SubjectCascader";
import { getLinkTableTitleNew, getLinkTableTitleSum, getLinkTable, getLinkTableAcc, getLinkTableNum, getChannelList } from "@/services/time";
import { getCourseList } from "@/services/order";
import { getTeamList } from "@/services/link";
import { getTermListNew } from "@/services/term";
import { getPromotionList } from "@/services/promotion";
import PowerWrapper from "@/components/PowerWrapper";
import funcBlock from '@/components/common/funcBlock'
import { timestampToDate, timestampToDateTotal, delUndefined, numFormat, deteleObject, formatNumberRgx2 } from "@/utils/utils";
import { getTeamCode, getAgentCode, getTeamRole } from '@/utils/auth'
import { initColumns, handlePrompt } from '@/utils/constant'

export default {
  name: "channel",
  components: {
    Pagination,
    PowerWrapper,
    funcBlock,
    DownExcel,
    SubjectCascader
  },
  data() {
    return {
      CurrRole: "timeChannel",
      dataList: [],
      listQuery: {
        index: 1,
        pageSize: 10,
        subject_type: '',
        class_open_time: '',
        dimension: 'day',
        course_id: null,
        study_step: null, // 学习进度
        term_id: null, // 学期
        promotion_position_id: null,
        member_id: (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) ? null : getAgentCode(),
        promotion_link_id: null,
        promotion_channel_id: null,
        orderColumn: 'dimension',
        orderType: 'desc',
        pay_amount: null,
      },
      createTime: [new Date(new Date().setHours(0, 0, 0, 0)).getTime() - 3600 * 1000 * 24 * 30, new Date(new Date().setHours(23, 59, 59, 0)).getTime()],
      pickerMinDate: "", // 第一次选中的时间
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const week = end.getDay();
              const millisecond = 1000 * 60 * 60 * 24;
              const minusDay = week !== 0 ? week - 1 : 6;
              const monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth();
              const currentYear = currentDate.getFullYear();
              const start = new Date(currentYear, currentMonth, 1);
              const end = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              const m = start.getMonth() - 1;
              start.setDate(1);
              start.setMonth(m);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate: time => {
          if (this.pickerMinDate) {
            const day1 = 93 * 24 * 3600 * 1000;
            const maxTime = this.pickerMinDate + day1;
            const minTime = this.pickerMinDate - day1;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
        }
      },
      total: 1,
      allTime: [
        {
          value: 'day',
          name: '分日'
        },
        {
          value: 'week',
          name: '分周'
        },
        {
          value: 'month',
          name: '分月'
        },
        {
          value: 'sum',
          name: '累计'
        }
      ],
      listLoading: false,
      statisticsArr: [],
      teamList: [],
      updateTime: null,
      downloadParam: {},
      dataAcc: {}, // 总计
      flagOrder: null,
      courseList: [],
      channelList: [],
      promotionList: [],
      tableColumns: [],
      termList: [] // 学期array
    };
  },
  computed: {
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    }
  },
  created() {
    // 获取table表头
    this.getTableTitle()
    // table
    this.getList()
    // 获取推广课程
    this.getCourseList()
    // 获取推广渠道
    this.getChannelList()
    // 获取团队成员信息
    this.getTeamList()
    // 获取学期列表
    this.getTermList()
  },
  methods: {
    subjectCascaderChange(subject_type) {
      this.listQuery.subject_type = subject_type;
    },
    enableChoose() {
      this.pickerMinDate = null
    },
    tableColumn({ row, rowIndex }) {
      return rowIndex === 0 ? 'row-special' : ''
    },
    handleStatus(value) {
      return value ? value === 'UNPAID' ? '未支付' : value === 'PAID' ? '已支付' : value === 'REFUND' ? '已退费' : '' : null
    },
    numberFormat(num) {
      return numFormat(num)
    },
    numberFormatNew(num, label) {
      const end = label ? label.replace(/^(.*[n])*.*(.|n)$/g, "$2") : label
      return end ? end === '率' ? num ? `${formatNumberRgx2(num * 100)} %` : '0%' : end === '数' ? numFormat(num) : end === '额' && label === '续报金额' ? formatNumberRgx2(num) : num : num
    },
    timestampToDate(time) {
      return timestampToDate(time)
    },
    timestampToDateTotal(time) {
      return timestampToDateTotal(time)
    },
    // 获取表头
    async getTableTitle() {
      const { dimension } = this.listQuery
      const res = dimension === 'sum' ? await getLinkTableTitleSum(getTeamCode()) : await getLinkTableTitleNew(getTeamCode())
      if (res && res.data && res.data.data && res.data.errCode === 0 && res.data.data.length > 0) {
        const { data } = res.data;
        if (data && data.length > 0) {
          // initColumns:全部列
          this.tableColumns = initColumns.filter(item => data.includes(item.prop))
        } else {
          this.tableColumns = []
        }
      } else if (res.data && res.data.errCode === 1016) {
        this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
        Cookie.remove('staffToken')
        setTimeout(() => {
          this.$router.push({ path: '/login' })
        }, 3000)
      } else {
        this.tableColumns = [];
      }
    },
    // 排序
    changeTableSort(column) {
      this.listQuery.orderColumn = column.prop;
      this.listQuery.orderType = column.order === "ascending" ? 'asc' : column.order === "descending" ? 'desc' : this.flagOrder;
      this.flagOrder = column.order === "ascending" ? 'asc' : 'desc'
      this.getList(null)
    },
    getList(btnName = '') {
      this.listLoading = true;
      const { listQuery, createTime } = this;
      const _listQuery = Object.assign({}, listQuery);
      Object.keys(_listQuery).forEach(key => {
        const query = _listQuery[key];
        if (Array.isArray(query) && query.indexOf('all') > -1) {
          Object.assign(_listQuery, {
            [key]: null
          })
        }
      });
      const { course_id, promotion_channel_id, promotion_position_id, term_id, member_id, study_step, dimension } = _listQuery
      const params = {
        ..._listQuery,
        course_id: course_id && course_id.length && course_id.filter(item => item !== 'null').length ? course_id.filter(item => item !== 'null').join(',') : null,
        promotion_channel_id: promotion_channel_id && promotion_channel_id.length && promotion_channel_id.filter(item => item !== 'null').length ? promotion_channel_id.filter(item => item !== 'null').join(',') : null,
        promotion_position_id: promotion_position_id && promotion_position_id.length && promotion_position_id.filter(item => item !== 'null').length ? promotion_position_id.filter(item => item !== 'null').join(',') : null,
        term_id: term_id && term_id.length && term_id.filter(item => item !== 'null').length ? term_id.filter(item => item !== 'null').join(',') : null,
        member_id: member_id && member_id.length && member_id.filter(item => item !== 'null').length ? member_id.filter(item => item !== 'null').join(',') : null,
        is_renewal: study_step ? study_step === '续报未截止' ? 1 : study_step === '续报已截止' ? 0 : null : null,
        is_unlock: study_step ? study_step === '首课未开课' ? 1 : study_step === '首课已开课' ? 0 : null : null,
        start_date: createTime && createTime[0] ? timestampToDate(createTime[0]) : null,
        end_date: createTime && createTime[1] ? timestampToDate(createTime[1]) : null
      }
      // 表头第一条数据
      const resTotal = getLinkTableNum(delUndefined({
        ...delUndefined(params),
        index: 1,
        pageSize: 1,
        dimension: null,
        orderColumn: null,
        orderType: null
      }))
      let resList = []
      if (dimension && dimension === 'sum') { // 累计
        resList = getLinkTableAcc(delUndefined({
          ...delUndefined(params),
          dimension: null
        }))
      } else {
        resList = getLinkTable(delUndefined({
          ...delUndefined(params)
        }))
      }
      Promise.all([resTotal, resList]).then((results) => {
        const resultTotal = results && results.length && results[0] && results[0].data;
        const res = results && results.length && results[1];
        const dataAcc = resultTotal && resultTotal.errCode === 0 && resultTotal.data && resultTotal.data.length > 0
          ? resultTotal.data[0] : [];
        this.updateTime = dataAcc.load_time || null;
        this.dataAcc = dataAcc;
        if (res && res.data && res.data.data && res.data.errCode === 0 && res.data.data.length > 0) {
          this.listLoading = false;
          const { data, total } = res.data;
          const data_cnt = [{
            ...dataAcc,
            data_cnt: total
          }]
          const dataList = deteleObject(data_cnt.concat(data || []));
          this.dataList = dataList && dataList.length > 1 ? dataList : []
          this.total = total
          // this.total = total ? Math.ceil(total + (total / (pageSize - 1)) - 1) : 0;
          if (btnName === 'search') {
            this.listQuery.index = 1;
          }
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: 'error', message: '登录时效已过期，请重新登录' })
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.listLoading = false;
          this.dataList = [];
          this.total = 0;
        }
      })
    },
    getPromotionList(channelCode) {
      const params = {
        teamCode: getTeamCode(),
        channelCode: channelCode
      }
      getPromotionList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.promotionList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.promotionList = [];
        }
      });
    },
    getTeamList() {
      const params = {
        teamCode: getTeamCode()
      }
      getTeamList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          let teamArr = []
          // 角色身份
          if (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) {
            teamArr = [
              {
                agentCode: 0,
                name: '无归属人'
              }
            ]
            this.teamList = teamArr.concat(res.data.data);
          } else {
            teamArr = [
              {
                agentCode: getAgentCode(),
                name: '我的'
              },
              {
                agentCode: 0,
                name: '无归属人'
              }
            ]
            this.teamList = teamArr;
          }
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.teamList = [];
        }
      });
    },
    getCourseList() {
      getCourseList().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.courseList = res.data.data.list;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.courseList = [];
        }
      });
    },
    getChannelList() {
      const teamCode = getTeamCode()
      getChannelList(teamCode).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.channelList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove('staffToken')
          setTimeout(() => {
            this.$router.push({ path: '/login' })
          }, 3000)
        } else {
          this.channelList = [];
        }
      });
    },
    getTermList() {
      getTermListNew().then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.termList = res.data.data;
        } else {
          this.termList = [];
        }
      });
    },
    handleChannel(value) {
      this.channelCode = value;
      this.listQuery.promotion_position_id = null;
      if (value && value.length && value.length === 1 && value.length !== 'null') {
        this.getPromotionList(value[0])
      } else {
        this.promotionList = [];
      }
    },
    changeDate(time) {
      this.handleSearch(time, 'date')
    },
    handleSearch(e, type) {
      const promotion_link_id = this.listQuery.promotion_link_id
      const idsArr = promotion_link_id ? promotion_link_id.replace(/[\uff0c]/g, ',').split(",") : []
      if (idsArr.length > 20) {
        this.$message({ type: 'error', message: '推广链接 ID 每次最多只能查 20 个，请删除掉多余的 ID' })
      } else {
        this.getTableTitle()
        this.getList('search');
      }
    },
    toggleSearch() {
      this.listQuery.orderColumn = this.listQuery.stat_dimension === 'total' ? 'promotion_link_id' : 'dimension';
      this.listQuery.orderType = 'asc';
      this.listQuery.index = 1;
      this.listQuery.pageSize = 10;
      this.getTableTitle()
      this.getList('search');
    },
    handlePrompt(str) {
      return handlePrompt(str)
    }
  }
};
</script>
<style lang="less" scoped>
@import '../../styles/common.less';
.special-weight{
  font-weight: bold;
  color: #606266
}
.topRight{
  .selectWidth{
    margin-right: 10px;
    width: 100px;
  }
}
.all_con{
  .l_con, .r_con{
    display: inline-block;
    vertical-align: top;
  }
  .l_con{
    width: 100%;
  }
}
.blockTit{
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
}
.blockTit:hover{
  text-decoration: underline;
}
.btn{
    float: right;
}
.icon-question{
  cursor: pointer;
}
</style>
